import { commonAPI } from '@redux/api'

import { URLS } from '@constants'
import {
  GETSearchParams,
  GETSearchType,
  POSTCreateSearchType,
  POSTDefaultSearchType,
  POSTSearchTitleType,
} from '@types'

export const searchApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    createSearchFilter: build.mutation<void, POSTCreateSearchType>({
      query: search => ({
        url: URLS.FRONT_CFG + '/search',
        method: 'POST',
        body: { ...search, overwriting: false },
      }),
      invalidatesTags: ['Search'],
    }),
    updateSearchFilter: build.mutation<GETSearchType, POSTCreateSearchType>({
      query: body => ({
        url: URLS.FRONT_CFG + '/search',
        method: 'POST',
        body: { ...body, overwriting: true },
      }),
      invalidatesTags: ['Search'],
    }),
    updateSearchFilterTitle: build.mutation<GETSearchType, POSTSearchTitleType>({
      query: body => ({
        url: URLS.FRONT_CFG + '/search/title',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Search'],
    }),
    updateDefaultSearchFilter: build.mutation<GETSearchType, POSTDefaultSearchType>({
      query: body => ({
        url: URLS.FRONT_CFG + `/search/default`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Search'],
    }),
    fetchSearchFilters: build.query<GETSearchType[], GETSearchParams>({
      query: ({ objectCodes, searchAssistantId }) => {
        const params = new URLSearchParams()
        objectCodes?.forEach(code => params.append('objectCodes', code))

        return {
          url:
            URLS.FRONT_CFG +
            `/search/searchAssistant/${searchAssistantId}/searches/by-filter-object-codes?${params.toString()}`,
        }
      },
      providesTags: ['Search'],
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const objectCodesString = queryArgs.objectCodes?.join()

        return `${endpointName}:${queryArgs.searchAssistantId}:${objectCodesString}:${queryArgs.instanceId}`
      },
    }),
    deleteSearchFilter: build.mutation<void, number>({
      query: id => ({
        url: URLS.FRONT_CFG + `/search/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Search'],
    }),
  }),
})

export const {
  useFetchSearchFiltersQuery,
  useCreateSearchFilterMutation,
  useUpdateSearchFilterMutation,
  useUpdateSearchFilterTitleMutation,
  useUpdateDefaultSearchFilterMutation,
  useDeleteSearchFilterMutation,
} = searchApi
